/**
 * <s-menu-overlay> — Full-screen editorial menu.
 * Hovering or focusing a top-level item ([data-menu-item]) makes it the active
 * item by setting data-active on the host; the block's CSS shows the matching
 * [data-menu-panel]. The active item persists until another item is hovered, so
 * the cursor can travel into the panel without it disappearing.
 */
class SMenuOverlay extends HTMLElement {
  #ac;

  connectedCallback() {
    this.#ac = new AbortController();
    const opts = { signal: this.#ac.signal };

    const activate = (event) => {
      if (!(event.target instanceof Element)) return;
      const item = event.target.closest('[data-menu-item]');
      if (!item || !this.contains(item)) return;
      this.dataset.active = item.dataset.menuItem;
    };

    this.addEventListener('pointerover', activate, opts);
    this.addEventListener('focusin', activate, opts);
  }

  disconnectedCallback() {
    this.#ac?.abort();
  }
}

if (!customElements.get('s-menu-overlay')) {
  customElements.define('s-menu-overlay', SMenuOverlay);
}
